import { IconWrapper } from '../runtime';
export default IconWrapper('cut', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M10.5 12.9997L8.15642 8.67309M6.30904 5.26253L4 0.999695M5.5 12.9997L12 0.999695M6 11.4997C6 12.8804 4.88071 13.9997 3.5 13.9997C2.11929 13.9997 1 12.8804 1 11.4997C1 10.119 2.11929 8.99969 3.5 8.99969C4.88071 8.99969 6 10.119 6 11.4997ZM15 11.4997C15 12.8804 13.8807 13.9997 12.5 13.9997C11.1193 13.9997 10 12.8804 10 11.4997C10 10.119 11.1193 8.99969 12.5 8.99969C13.8807 8.99969 15 10.119 15 11.4997Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});